import apiSlice from "./ApiSlice";

const facultyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllFacultyData: builder.query({
      providesTags: ["faculty"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/faculty",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteFacultyById: builder.mutation({
      invalidatesTags: ["faculty"],
      query: (id: any) => ({
        url: `/faculty/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addFaculty: builder.mutation({
      invalidatesTags: ["faculty"],
      query: (body) => ({
        url: `/faculty/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getFacultyById: builder.query({
      providesTags: ["faculty"],
      query: (id: string) => {
        return {
          url: `/faculty/${id}`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateFacultyById: builder.mutation({
      invalidatesTags: ["faculty"],
      query: ({ body, id }) => ({
        url: `/faculty/${id}`,
        method: "PUT",
        body,
      }),
    }),

     //get AllFaculty
     getAllFaculty: builder.query({
      providesTags: ["faculty"],
      query: () => {
        return {
          url: `/faculty`,
          method: "GET",
        };
      },
    }),


    // change status of delivery date
    changeStatusFacultyById: builder.mutation({
      invalidatesTags: ["faculty"],
      query: ({ body, id }) => ({
        url: `/faculty/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllFacultyDataQuery,
  useDeleteFacultyByIdMutation,
  useAddFacultyMutation,
  useGetFacultyByIdQuery,
  useGetAllFacultyQuery,
  useUpdateFacultyByIdMutation,
  useChangeStatusFacultyByIdMutation,
} = facultyApi;
